/* eslint-disable jsx-a11y/no-static-element-interactions */
import { CommaArrayParam } from 'helpers/CommaArrayParam';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useQueryParam, withDefault } from 'use-query-params';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import { useEffect, useState } from 'react';
import { BOLT_STEPS_TITLE, STEPS_TITLE } from '../constants';
import { STEPS_TITLE_FOUR_STAGES } from '../constants_four_stages';

import styles from './styles';

const PcModelOptionsReviewStep = ({
  step,
  expandedIndex,
  index,
  uid,
  hasPanelPrints,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  // const [optionStep, setOptionStep] = useState(null);
  const { options, currentOptions } = usePcConfigurator();

  const correctOrder = [
    'samsung monitors - aftershock recommended',
    'steelseries accessories - aftershock recommended',
    'pax weekend only - free nzxt keyboard with purchase',
    'norton - vpn software',
    'cpu',
    'motherboard',
    'ram',
    'graphics card',
    'power supply unit',
    'warranty',
    'wi-fi',
    'cpu cooling system', 
    'network card',
    'thermal compound',
    'primary ssd',
    'secondary ssd',
    'first hard drive',
    'second hard drive',
    'operating system',
    'chassis',
    'chassis fans',
    'case lighting',
    'custom cable sleeves',
    'charms',
    'gpu customisation',
    'wi-fi & bluetooth',
    'ultra-labs customisation - front panel',
    'ultra-labs customisation - side panel',
    'ultra-labs customisation - back panel',
    'ultra-labs customisation - top panel',
    'ultra-labs customisation - fan grills',
    'lcd panels',
    'special bundles',
    'apc uninterrupted power supplies - aftershock recommended',
    'bundles',
    'free gift',
    'primary monitor',
    'secondary monitor',
    'precision keyboard',
    'precision mouse',
    'precision mouse mat',
    'headset',
    'microsoft office',
    'virus protection',
    'mics',
    'webcam',
    'sound system',
    'racing sims',
    'external storage',
    'backup power supply',
    'electric standing desk',
    'ergonomic chairs',
  ];

  const sortedCurrentOptions = currentOptions.sort((a, b) => {
    return (
      correctOrder.indexOf(a.group_title.toLowerCase()) -
      correctOrder.indexOf(b.group_title.toLowerCase())
    );
  });

  let UPDATED_STEPS_TITLE = STEPS_TITLE;
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;
  let filteredOptions;

  if (currentOptions?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      UPDATED_STEPS_TITLE = STEPS_TITLE_FOUR_STAGES;

      filteredOptions = sortedCurrentOptions.filter((option) => {
        if (step == 'ultralabs') {
          return option.group_step_new === 'ultra-labs';
        } else if (step == 'accessoriesnew') {
          return option.group_step_new === 'accessories (new)';
        } else {
          return option.group_step_new === step;
        }
      });
    } else if (
      (uid === 'bolt-lite' ||
        uid === 'bolt-test' ||
        uid === 'bolt' ||
        uid === 'bolt-plus') &&
      hasPanelPrints
    ) {
      UPDATED_STEPS_TITLE = BOLT_STEPS_TITLE;

      filteredOptions = sortedCurrentOptions.filter((option) => {
        if (step == 'panel_print') {
          return option.group_type === 'panel_print';
        } else {
          return option.group_step_new === step;
        }
      });
    } else {
      UPDATED_STEPS_TITLE = STEPS_TITLE;

      filteredOptions = sortedCurrentOptions.filter(
        (option) => option.group_step_new === step,
      );
    }
  }

  const [, setCurrentStep] = useQueryParam('step');
  const [completed, setCompleted] = useQueryParam(
    'completed',
    withDefault(CommaArrayParam, []),
  );

  const handleChangeClick = (option) => {
    if (option.group_type === 'panel_print') {
      setCurrentStep(option.group_type);
    } else {
      setCurrentStep(option.group_step_new);
    }
    setCompleted(completed.filter((item) => item !== option.group_type));
    setTimeout(() => {
      document
        .getElementById(`group-type-${option.group_type}`)
        .scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
    }, 500);
  };

  const toggleShowOptions = () => {
    setShowOptions(!showOptions);
  };

  useEffect(() => {
    if (expandedIndex === index) {
      setShowOptions(true);
    }
  }, []);

  return (
    <div className="pc-model-options-review-step">
      <div className="title" onClick={toggleShowOptions}>
        <div className="titleIcon">
          {showOptions ? (
            <Image
              draggable={false}
              src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronUp.svg?v=1713890188"
              alt="title-icon"
              width={24}
              height={24}
            />
          ) : (
            <Image
              draggable={false}
              src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronDown.svg?v=1713890140"
              alt="title-icon"
              width={24}
              height={24}
            />
          )}
        </div>

        {UPDATED_STEPS_TITLE[step]}
      </div>

      {showOptions && (
        <div>
          {filteredOptions.map((option) => (
            <div
              key={`${option.group_type}-${option.variant_id}`}
              className="group-container"
            >
              <div className="group">
                <div className="group-title">
                  <div className="group-title-text">{option.group_title}:</div>
                </div>
                <div className="group-option">
                  <span className="component-name">
                    {!option.title && <em>- None -</em>}
                    {option.title && option.title}
                  </span>

                  <button
                    className="action"
                    type="button"
                    onClick={() => handleChangeClick(option)}
                  >
                    Change
                  </button>
                </div>
              </div>

              <span className="component-name-mobile">
                {!option.title && <em>- None -</em>}
                {option.title && option.title}
              </span>
            </div>
          ))}
        </div>
      )}

      <style jsx>{styles}</style>
    </div>
  );
};

PcModelOptionsReviewStep.propTypes = {
  step: PropTypes.string.isRequired,
};

export default PcModelOptionsReviewStep;
